var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C18.094 15 20.625 12.4687 20.625 9.375C20.625 6.28131 18.094 3.75 15 3.75C11.906 3.75 9.375 6.28131 9.375 9.375C9.375 12.4687 11.906 15 15 15ZM15 17.8125C11.2736 17.8125 3.75 19.7111 3.75 23.4375V26.25H26.25V23.4375C26.25 19.7111 18.7264 17.8125 15 17.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/Personal.98a515a645af12b0c2cbe5c0132557cf.svg";
export { ForwardRef as ReactComponent };